import { cn } from "@/lib/class-control"
import { PaymentStatus } from "@/types/payment";

const STATUS_CONFIG: Record<PaymentStatus, { bg: string; text: string }> = {
  Solicitado: { bg: "bg-[#7846ff]", text: "text-[#f5f2ff]" },
  Aprovado: { bg: "bg-blue-500/20", text: "text-blue-300" },
  Pago: { bg: "bg-green-500/20", text: "text-green-300" },
  Cancelado: { bg: "bg-red-500/20", text: "text-red-300" },
}

export function StatusBadge({ status }: { status: PaymentStatus }) {
  const { bg, text } = STATUS_CONFIG[status] ?? STATUS_CONFIG.Solicitado

  return (
    <div className="flex items-center justify-center w-[100px]">
      <div
        className={cn(
          "w-[80px] h-[22px] rounded-[20px] flex items-center justify-center",
          bg
        )}
      >
        <span className={cn("text-[12px] font-normal text-center", text)}>
          {status}
        </span>
      </div>
    </div>
  )
}
